import { useEffect, useState } from 'react';

/** 입력이 멈춘 뒤에만 서버에 묻는다 — 토큰을 칠 때마다 검증·미리보기를 부르지 않게 */
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
};
